import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    itemId: '',
    itemName: '',
    skuId: '',
    categoryId: '',
    categoryName: '',
    lifeCycle: '',
    leadTime: '',
    orderLot: '',
    consumption: '',
    image: ''
  },

  getters: {
    itemId(state) {
      return state.itemId
    },
    itemName(state) {
      return state.itemName
    },
    skuId(state) {
      return state.skuId
    },
    categoryId(state) {
      return state.categoryId
    },
    categoryName(state) {
      return state.categoryName
    },
    lifeCycle(state) {
      return state.lifeCycle
    },
    leadTime(state) {
      return state.leadTime
    },
    orderLot(state) {
      return state.orderLot
    },
    detailConsumption(state) {
      return state.consumption
    },
    image(state) {
      return state.image
    }
  },

  mutations: {
    detail(state, payload) {
      state.itemId = payload.itemId
      state.itemName = payload.itemName
      state.skuId = payload.skuId
      state.categoryId = payload.categoryId
      state.categoryName = payload.categoryName
      state.lifeCycle = payload.lifeCycle
      state.leadTime = payload.leadTime
      state.orderLot = payload.orderLot
      state.consumption = payload.consumption
      state.image = payload.image
    },

    lifeCycle(state, payload) {
      state.lifeCycle = payload
    },
    leadTime(state, payload) {
      state.leadTime = payload
    },
    orderLot(state, payload) {
      state.orderLot = payload
    },

    reset(state) {
      state.itemId = ''
      state.itemName = ''
      state.skuId = ''
      state.categoryId = ''
      state.categoryName = ''
      state.lifeCycle = ''
      state.leadTime = ''
      state.orderLot = ''
      state.consumption = ''
      state.image = ''
    }
  },

  actions: {
    /**
     * itemの詳細情報を取得
     * sku_idを空白に設定し、itemであることを識別
     */
    getDetailItem({ commit }, payload) {
      const data = {
        item_id: payload.itemId
      }

      api.get('/api/v2/detail/item/get', data)
        .then((res) => {
          const item = res.data.item
          const detail = {
            itemId: item.part_no,
            itemName: item.item_name,
            skuId: '',
            categoryId: item.category_id,
            categoryName: item.category_name,
            lifeCycle: item.life_cycle,
            leadTime: item.lead_time,
            orderLot: item.lot,
            consumption: item.consumption,
            image: item.image
          }

          commit('detail', detail)
        })
    },

    /**
     * skuの詳細情報を取得
     * sku_idを設定し、skuとして識別
     */
    getDetailSku({ commit }, payload) {
      const data = {
        sku_id: payload.skuId
      }

      api.get('/api/v2/detail/sku/get', data)
        .then((res) => {
          const sku = res.data.sku
          const detail = {
            itemId: sku.part_no,
            itemName: sku.item_name,
            skuId: sku.sku_id,
            categoryId: sku.category_id,
            categoryName: sku.category_name,
            lifeCycle: sku.life_cycle,
            leadTime: sku.lead_time,
            orderLot: sku.lot,
            consumption: sku.consumption,
            image: sku.image
          }

          commit('detail', detail)
        })
    },

    /**
     * item設定を更新
     */
    setItemset({ commit }, payload) {
      const data = {
        item_id: payload.itemId,
        life_cycle: payload.lifeCycle,
        lead_time: payload.leadTime,
        lot: payload.lot
      }

      return api.put('/api/v2/itemset/put', data)
        .then((res) => {
          commit('lifeCycle', payload.lifeCycle)
          commit('leadTime', payload.leadTime)
          commit('orderLot', payload.lot)
        })
    },

    /**
     * 詳細情報を初期化
     */
    resetDetail({ commit }) {
      commit('reset')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/detail.js